import React from "react";
import {
  DownloadOutlined,
  CheckOutlined,
  CopyOutlined,
  UpOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { Tooltip } from "antd";
import FileTypeIcon, { hasMappedFileTypeIcon } from "@/components/ui/FileTypeIcon";

import "./DialogPopupSourceDocuments.css";

function DialogPopupSourceDocuments({
  sourceDialogOpen,
  sourceDialogContent,
  expandedSources,
  copiedSource,
  getPreviewText,
  downloadFile,
  location,
  copySourceContent,
  toggleSourceExpansion,
  fixSpacing,
}) {
  return (
    <>
      {sourceDialogOpen && sourceDialogContent.length > 0 && (
        <div className="dialog-popup-source-documents-section">
          <label className="dialog-popup-source-documents-section-label">
            <span className="dialog-popup-source-documents-section-title">Source Documents</span>
            <span className="dialog-popup-source-documents-section-description">
              Reference materials used to generate this section
            </span>
          </label>

          <div className="dialog-popup-source-documents-sources">
            {sourceDialogContent.map((source, index) => {
              const isExpanded = expandedSources.has(index);
              const isCopied = copiedSource === index;
              const sourceFilename = source.document || source.file_id;
              const hasFileTypeIcon = hasMappedFileTypeIcon(sourceFilename);

              return (
                <div key={index} className="dialog-popup-source-documents-source-card">
                  <div className="dialog-popup-source-documents-source-header">
                    <div className="dialog-popup-source-documents-source-info">
                      <div
                        className={`dialog-popup-source-documents-source-icon ${
                          hasFileTypeIcon ? "dialog-popup-source-documents-source-icon-file-type" : ""
                        }`}
                      >
                        <FileTypeIcon
                          filename={sourceFilename}
                          imageClassName="dialog-popup-source-documents-source-icon-image"
                        />
                      </div>
                      <div className="dialog-popup-source-documents-source-details">
                        <div className="dialog-popup-source-documents-source-name">{sourceFilename}</div>
                        <div className="dialog-popup-source-documents-source-preview">
                          {getPreviewText(source.content)}
                        </div>
                      </div>
                    </div>

                    <div className="dialog-popup-source-documents-source-actions">
                      {true && (
                        <button
                          type="button"
                          onClick={() => {
                            downloadFile(source.file_id);
                          }}
                          className="dialog-popup-source-documents-source-action"
                          title="Download Document"
                        >
                          <Tooltip title="Download Document">
                            <DownloadOutlined />
                          </Tooltip>
                        </button>
                      )}

                      {location !== "online" && (
                        <button
                          type="button"
                          onClick={() => copySourceContent(source.content, index)}
                          className="dialog-popup-source-documents-source-action"
                          title="Copy content"
                        >
                          {isCopied ? (
                            <CheckOutlined />
                          ) : (
                            <Tooltip title="Copy content">
                              <CopyOutlined />
                            </Tooltip>
                          )}
                        </button>
                      )}

                      {source.content !== "" && (
                        <button
                          type="button"
                          onClick={() => toggleSourceExpansion(index)}
                          className="dialog-popup-source-documents-source-action"
                          title={isExpanded ? "Collapse" : "Expand"}
                        >
                          {isExpanded ? (
                            <Tooltip title="Collapse">
                              <UpOutlined />
                            </Tooltip>
                          ) : (
                            <Tooltip title="Expand">
                              <DownOutlined />
                            </Tooltip>
                          )}
                        </button>
                      )}
                    </div>
                  </div>

                  {isExpanded && (
                    <div className="dialog-popup-source-documents-source-content">
                      <pre className="dialog-popup-source-documents-source-text">{fixSpacing(source.content)}</pre>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}

export default DialogPopupSourceDocuments;
